import { PATH_DELIMITER, SMS_HISTORY_PATH } from '../../../constant/Constant';
import { SET_GRID_DATA } from '../../component/TableBoxModule';
import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { request } from '../../ApiModule';
import NullCheckUtil from '../../../util/NullCheckUtil';
import produce from 'immer';

const ACTION_SMS_HISTORY_SEARCH = SMS_HISTORY_PATH + PATH_DELIMITER + 'ACTION_SMS_HISTORY_SEARCH';

export const actionSmsHistorySearch = createAction(ACTION_SMS_HISTORY_SEARCH);

export function* smsHistorySagas() {
    yield takeEvery(ACTION_SMS_HISTORY_SEARCH, actionSmsHistorySearchSaga);
}

function* actionSmsHistorySearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: '/api/sms-send',
        params,
        callback,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        yield put({
            type: SET_GRID_DATA,
            payload: result,
        });
    }
}
